"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Place = {
    elemName: '場所',
    type: 'inline',
    doc: '場所情報をマークアップします。',
    example: '〔日本橋〕',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$1}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Place {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<placeName {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</placeName>`,
    docxTemplate: `<w:r><w:rPr><w:rFonts w:hint="eastAsia"/></w:rPr><w:t>{{$text}}</w:t></w:r>`,
    latexTemplate: '{{$text}}'
};
exports.default = Place;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGxhY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9QbGFjZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLE1BQU0sS0FBSyxHQUFtQjtJQUM3QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxRQUFRO0lBQ2QsR0FBRyxFQUFFLGlCQUFpQjtJQUN0QixPQUFPLEVBQUUsT0FBTztJQUNoQixlQUFlLEVBQUUsQ0FBQztJQUNsQixlQUFlLEVBQUUsQ0FBQztJQUNsQixZQUFZLEVBQUUsUUFBUTtJQUN0QixZQUFZLEVBQUUsZ0VBQWdFO0lBQzlFLFdBQVcsRUFBRSxpRUFBaUU7SUFDOUUsWUFBWSxFQUFFLDZFQUE2RTtJQUMzRixhQUFhLEVBQUUsV0FBVztDQUMxQixDQUFDO0FBRUYsa0JBQWUsS0FBSyxDQUFDIn0=